/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ConfigurationForNextGenReportBase extends models.ReportConfiguration {
    constructor() {
        super();
        this.setDiscriminator("ConfigurationForNextGenReportBase");
    }

    getFixupPrototypeFunction() { return ConfigurationForNextGenReportBase.fixupPrototype; }

    static newInstance(model: Partial<ConfigurationForNextGenReportBase>): ConfigurationForNextGenReportBase {
        let obj = Object.assign(new ConfigurationForNextGenReportBase(), model);
        ConfigurationForNextGenReportBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ConfigurationForNextGenReportBase>): ConfigurationForNextGenReportBase {
        if (!model) return null;
        return ConfigurationForNextGenReportBase.newInstance(<ConfigurationForNextGenReportBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ConfigurationForNextGenReportBase) {
        if (!obj) return;

        models.ConfigurationForNextGenReportBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ConfigurationForNextGenReportBase): boolean {
        if (models.ReportConfiguration.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ConfigurationForNextGenReportBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.limit === undefined) {
            this.limit = 0;
        }
    }

    /**
     * If set, limits the results to given number.
     */
    limit: number;

}
